import { LooseAutocomplete } from '@b2b/types/core';
import { z } from 'zod';

export const addressFields = z.object({
  streetAddress1: z.string().min(1),
  streetAddress2: z.string().optional(),
  state: z.string(),
  city: z.string().min(1),
  country: z.string().min(1),
  zipCode: z.string().min(1),
});

export const addressSchema = addressFields.superRefine((address, ctx) => {
  addressRefinements(address, ctx);
});

export type Address = z.infer<typeof addressSchema>;

export function addressRefinements(address: Address, ctx: z.RefinementCtx) {
  if (requiresStateValidation(address.country) && !address.state) {
    ctx.addIssue({
      code: 'custom',
      path: ['state'],
      message: 'state is required',
    });
  }
}

function requiresStateValidation(country?: LooseAutocomplete<'Canada' | 'United States'>) {
  switch (country) {
    case 'Canada':
    case 'United States':
      return true;
    default:
      return false;
  }
}
